import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const teddyeldConfig: TSPConfig = {
  key: 'teddyeld',
  name: 'TeddyELD',
  category: TSPCategory.API_KEY,
  helpText: (
    <ol>
      <li>
        Contact your TeddyELD account representative to obtain your API key.
      </li>
      <li>Input the API Key here.</li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default teddyeldConfig;
